import Modal from 'react-bootstrap/Modal';
import React, { useState, useEffect } from "react";
import axios from "axios";
import '../../Style/Checkbox.scss';
import '../../Style/CompanyUnitInsert.scss';
import { errorAlert, handleSuccess } from '../../Components/Alerts';
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import '../../Style/__button.scss'
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import { TextareaAutosize } from '@mui/material';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AddElementsButton } from '../../Components/AddElementsButton';

function InsertCompanyUnit(props) {
    const headers = authHeader();
    const loginEmail = LoginUserDetailed();


    const [unitName, setUnitName] = useState("");
    const [identificationNumber, setIdentificationNumber] = useState("");
    const [companyID, setCompanyID] = useState(0);
    const [unitAdress, setUnitAddres] = useState("");
    const [cityID, setCityID] = useState("");
    const [stateID, setStateID] = useState(0);
    const [phoneNumbers, setPhoneNumbers] = useState("");
    const [email, setEmail] = useState("");
    const [comment, setComment] = useState("");
    // const [createdByUser, setCreatedByUser] = useState("");
    const [isActive, setIsActive] = useState(true);

    const [states, setStates] = useState([]);
    const [city, setCity] = useState([]);
    const [companies, setCompanies] = useState([]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const stateData = {
            UnitName: unitName,
            IdentificationNumber: identificationNumber,
            CompanyID: companyID,
            UnitAdress: unitAdress,
            CityID: cityID,
            PhoneNumbers: phoneNumbers,
            Email: email,
            Comment: comment,
            CreatedByUser: loginEmail,
            IsActive: isActive,
        };
        axios.post(ApiLink.API_URL + 'CompanyUnits', stateData, { headers })
            .then((response) => {
                handleSuccess("Company Added Successfully");
                setUnitName("");
                setIdentificationNumber("");
                setUnitAddres("");
                setCityID("");
                setCompanyID(0);
                setCity([]);
                setPhoneNumbers("");
                setEmail("");
                setComment("");
                setIsActive(true);
                props.onHide();
                props.refreshData(); // Thirrja e funksionit per refresh te dhenave

            })
            .catch((error) => {
                console.error(error);
                if (error.response && error.response.status === 409) {
                    errorAlert(error.response.data);
                } else {
                    errorAlert("An unknown error occurred while processing the request.");
                }
            });
    };
    const fetchCompanies = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies', { headers });
            setCompanies(response.data);
            // setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const clearAll = () => {
        setUnitName("");
        setIdentificationNumber("");
        setUnitAddres("");
        setCityID("");
        setCompanyID(0);
        setCity([]);
        setPhoneNumbers("");
        setEmail("");
        setComment("");
        setIsActive(true);
        props.onHide();
    }

    useEffect(() => {
        const headers = authHeader();
        axios.get(ApiLink.API_URL + 'states', { headers })
            .then((response) => {
                setStates(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const fetchCityByState = async (selectedStateID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Cities/getcitybystate', { headers, params: { stateid: selectedStateID } });
            setCity(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // useEffect(() => {
    //     const headers = authHeader();
    //     axios.get(ApiLink.API_URL + 'cities', { headers })
    //         .then((response) => {
    //             setCity(response.data);
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         });
    // }, []);

    const handleAutocompleteChangeCompanyID = (event, value) => {
        if (value && value.CompanyID) {
            setCompanyID(value.CompanyID);

        } else {
            // Në rast se vlera është pastruar
            setCompanyID(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsCompanyID = {
        options: companies,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.CompanyName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.CompanyName}
                    </span>
                </li>
            </>
        ),
    };

    const handleAutocompleteChangeState = (event, value) => {
        if (value && value.StateID) {
            setStateID(value.StateID);
            fetchCityByState(value.StateID);

        } else {
            // Në rast se vlera është pastruar
            setStateID(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsState = {
        options: states,
        getOptionLabel: (option) =>
            option.StateName || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.StateName}
                    </span>
                </li>
            </>
        ),
    };

    const handleAutocompleteChangeCity = (event, value) => {
        if (value && value.CityID) {
            setCityID(value.CityID);

        } else {
            // Në rast se vlera është pastruar
            setCityID(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsCity = {
        options: city,
        getOptionLabel: (option) =>
            option.CityName || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.CityName}
                    </span>
                </li>
            </>
        ),
    };


    useEffect(() => {
        fetchCompanies();
    }, [])


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header >
                <Modal.Title id="contained-modal-title-vcenter">
                    Krijo njesi të re
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit} className="InsertCompanyUnit__Container">
                    <div className='InsertCompanyUnit__Container__FirstDiv' >
                        <TextField
                            id="UnitName"
                            label="Emri i njesis"
                            variant="outlined"
                            type="text"
                            name='UnitName'
                            autoComplete='off'
                            value={unitName}
                            onChange={event => { setUnitName(event.target.value); }}
                            style={{ width: "100%" }}
                            required
                        />
                    </div>
                    <div className='InsertCompanyUnit__Container__SecondDiv'>
                        <div className="InsertCompanyUnit__Container__SecondDiv__box">
                            <TextField
                                className='InsertModal__Container__Form__Container2__field__InsertField'
                                id="Numri Identifikues"
                                label="identificationNumber"
                                variant="outlined"
                                type="text"
                                name='identificationNumber'
                                autoComplete='off'
                                value={identificationNumber}
                                onChange={event => { setIdentificationNumber(event.target.value) }}
                                required
                            />
                        </div>
                        <div className='InsertCompanyUnit__Container__SecondDiv__box'>
                            <Autocomplete
                                fullWidth
                                {...defaultPropsCompanyID}
                                id="CompanyID"
                                includeInputInList
                                // value={field}
                                // style={{ width: "100%" }}

                                onChange={handleAutocompleteChangeCompanyID}
                                isOptionEqualToValue={(option, value) => option.CompanyID === value.CompanyID} // Shto funksionin isOptionEqualToValue
                                renderInput={(params) => (
                                    <TextField
                                        // className='InsertModal__Container__Form__Container2__field__InsertField'
                                        {...params}
                                        label="Zgjedh Kompanin"
                                        // variant="filled"
                                        // onKeyPress={handleKeyPress}
                                        required
                                    />
                                )}
                                ListboxProps={{
                                    style: {
                                        maxHeight: '250px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                        overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className='InsertCompanyUnit__Container__SecondDiv'>
                        <div className='InsertCompanyUnit__Container__SecondDiv__box'>
                            <Autocomplete
                                fullWidth
                                {...defaultPropsState}
                                id="StateID"
                                includeInputInList
                                // value={field}
                                // style={{ width: "100%" }}

                                onChange={handleAutocompleteChangeState}
                                isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                                renderInput={(params) => (
                                    <TextField
                                        // className='InsertModal__Container__Form__Container2__field__InsertField'
                                        {...params}
                                        label="Zgjedh Shtetin"
                                        // variant="filled"
                                        // onKeyPress={handleKeyPress}
                                        required
                                    />
                                )}
                                ListboxProps={{
                                    style: {
                                        maxHeight: '250px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                        overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                    },
                                }}
                            />
                        </div>
                        <div className='InsertCompanyUnit__Container__SecondDiv__box'>
                            <Autocomplete
                                fullWidth
                                {...defaultPropsCity}
                                id="CityID"
                                includeInputInList
                                // value={field}
                                // style={{ width: "100%" }}

                                onChange={handleAutocompleteChangeCity}
                                isOptionEqualToValue={(option, value) => option.CityID === value.CityID} // Shto funksionin isOptionEqualToValue
                                renderInput={(params) => (
                                    <TextField
                                        // className='InsertModal__Container__Form__Container2__field__InsertField'
                                        {...params}
                                        label="Zgjedh Qytetin"
                                        // variant="filled"
                                        // onKeyPress={handleKeyPress}
                                        required
                                    />
                                )}
                                ListboxProps={{
                                    style: {
                                        maxHeight: '250px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                        overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className='InsertCompanyUnit__Container__FirstDiv' >
                        <TextField
                            id="UnitAddress"
                            label="Adresa e njesis"
                            variant="outlined"
                            type="text"
                            name='UnitAddress'
                            autoComplete='off'
                            value={unitAdress}
                            onChange={event => { setUnitAddres(event.target.value); }}
                            style={{ width: "100%" }}
                            required
                        />
                    </div>
                    <div className='InsertCompanyUnit__Container__SecondDiv'>
                        <div className="InsertCompanyUnit__Container__SecondDiv__box">
                            <TextField
                                className='InsertModal__Container__Form__Container2__field__InsertField'
                                id="PhoneNumber"
                                label="Numri Telefonit"
                                variant="outlined"
                                type="text"
                                name='PhoneNumber'
                                autoComplete='off'
                                value={phoneNumbers}
                                onChange={event => { setPhoneNumbers(event.target.value) }}
                            />
                        </div>
                        <div className='InsertCompanyUnit__Container__SecondDiv__box'>
                            <TextField
                                className='InsertModal__Container__Form__Container2__field__InsertField'
                                id="Email"
                                label="Email"
                                variant="outlined"
                                type="text"
                                name='Email'
                                autoComplete='off'
                                value={email}
                                onChange={event => { setEmail(event.target.value) }}
                            />
                        </div>
                    </div>
                    <div className='InsertCompanyUnit__Container__FirstDiv' >
                        <TextareaAutosize style={{ height: "100px", width: "100%" }}
                            // className="InsertModal__Container__Form__Container2__field__descriptionArea"
                            id="Description"
                            label="Përshkrimi"
                            variant="outlined"
                            placeholder='Përshkrimi'
                            type="text"
                            autoComplete='off'
                            name='Description'
                            value={comment}
                            onChange={event => setComment(event.target.value)}
                        />
                    </div>
                    <div className='InsertCompanyUnit__Container__Buttons'>
                        <Stack direction="row" spacing={2}>
                            <Button variant="contained" color="success" type="submit">
                                Ruaj
                            </Button>
                            <Button variant="contained" color="error"
                                onClick={clearAll}>
                                Anulo
                            </Button>
                        </Stack>

                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default function InsertData(props) {
    const [modalShow, setModalShow] = React.useState(false);

    const handleRefreshData = () => {
        props.fetchData(); // Thirrja e funksionit per refresh te dhenave
    };

    return (
        <>
            {/* <button className="button-68" onClick={() => setModalShow(true)}>
                <i class="bi bi-plus-circle">  </i>  <span style={{ marginLeft: "5px" }} />Shto njësi të re
            </button> */}
            <AddElementsButton
                text="Shto njësi të re"
                onClick={() => setModalShow(true)}
                icon="bi bi-plus-circle"
                className="button-68"
            />

            <InsertCompanyUnit
                show={modalShow}
                onHide={() => setModalShow(false)}
                refreshData={handleRefreshData}
            />
        </>
    );
}